import React, { useEffect, useState } from "react";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControl,
	FormLabel,
	IconButton,
	TextField,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import PasswordStrengthBar from "react-password-strength-bar";
import Axios from "axios";
import constants from "../Constants";
import AlertMsg from "../component/AlertMsg";
import CloseIcon from "@mui/icons-material/Close";

function ResetPassModal({ open, setOpen, infoUsername, fetchData }) {
	const [username, setUsername] = useState(null);
	const [usernameToEdit, setUsernameToEdit] = useState();
	const [passwordToEdit, setPasswordToEdit] = useState();
	const [confirmPasswordToEdit, setConfirmPasswordToEdit] = useState();
	const [showPass, setShowPass] = useState(false);
	const [showConfirmPass, setShowConfirmPass] = useState(false);
	const [resetMsg, setResetMsg] = useState(null);

	const handleUsernameChange = e => {
		setUsernameToEdit(e.target.value);
	};
	const handlePasswordChange = e => {
		setPasswordToEdit(e.target.value);
	};
	const handleConfirmPasswordChange = e => {
		setConfirmPasswordToEdit(e.target.value);
	};

	useEffect(() => {
		setUsername(infoUsername);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [infoUsername]);

	const resetPassword = async () => {
		const data = {
			username: usernameToEdit,
			password: passwordToEdit,
		};
		try {
			const response = await Axios.patch(
				constants.baseUrl + "/school/resetpassword",
				data,
				{
					headers: {
						authorization: "Bearer " + localStorage.getItem("schoolToken"),
					},
				}
			);
			const status = response.data.status;
			if (status === 202) {
				fetchData();
				setResetMsg({
					type: true,
					header: "عملیات با موفقیت انجام شد",
					message: "تغییرات اعمال شد",
				});
			} else {
				setResetMsg({
					type: false,
					header: "تلاش ناموفق",
					message: response.data.result.message,
				});
			}
		} catch (err) {
			setResetMsg({
				type: false,
				header: "تلاش ناموفق",
				message: "خطا در برقراری ارتباط",
			});
		}
	};

	const handleResetPassword = () => {
		if (!usernameToEdit || !passwordToEdit || !confirmPasswordToEdit) {
			setResetMsg({
				type: false,
				header: "تلاش ناموفق",
				message: "همه فیلد ها را پر کنید",
			});
		} else if (passwordToEdit !== confirmPasswordToEdit) {
			setResetMsg({
				type: false,
				header: "تلاش ناموفق",
				message: "رمز عبور مطابقت ندارد",
			});
		} else {
			resetPassword();
		}
	};

	return (
		<Dialog open={open} fullWidth maxWidth="sm">
			<IconButton
				sx={{ position: "absolute", top: 5, left: 5 }}
				onClick={() => {
					setOpen(false);
					setResetMsg(null);
				}}>
				<CloseIcon />
			</IconButton>
			<DialogTitle>تغییر نام کاربری و رمز عبور</DialogTitle>
			<DialogContent>
				<FormControl fullWidth margin="normal">
					<FormLabel sx={{ fontWeight: "bold", mb: 0.7 }}>نام کاربری</FormLabel>
					<TextField
						required
						value={usernameToEdit}
						onChange={handleUsernameChange}
						placeholder={username}
					/>
				</FormControl>
				<FormControl fullWidth margin="normal">
					<FormLabel sx={{ fontWeight: "bold", mb: 0.7 }}>رمز عبور</FormLabel>
					<TextField
						required
						value={passwordToEdit}
						type={!showPass ? "password" : "text"}
						sx={{ position: "relative" }}
						onChange={handlePasswordChange}
						placeholder={"رمز عبور"}
					/>
					<IconButton
						onClick={() => setShowPass(!showPass)}
						edge="end"
						sx={{ position: "absolute", top: 37, left: 2 }}>
						{showPass ? <VisibilityOff /> : <Visibility />}
					</IconButton>
				</FormControl>
				<PasswordStrengthBar
					style={{ width: "100%" }}
					scoreWords={["بسیار ضعیف", "ضعیف", "متوسط", "خوب", "عالی"]}
					shortScoreWord={"خیلی کوتاه"}
					password={passwordToEdit}
				/>
				<FormControl fullWidth margin="normal">
					<FormLabel sx={{ fontWeight: "bold", mb: 0.7 }}>تایید رمز عبور</FormLabel>
					<TextField
						required
						value={confirmPasswordToEdit}
						type={!showConfirmPass ? "password" : "text"}
						sx={{ position: "relative" }}
						onChange={handleConfirmPasswordChange}
						placeholder={"تایید رمز عبور"}
					/>
					<IconButton
						onClick={() => setShowConfirmPass(!showConfirmPass)}
						edge="end"
						sx={{ position: "absolute", top: 37, left: 2 }}>
						{showConfirmPass ? <VisibilityOff /> : <Visibility />}
					</IconButton>
				</FormControl>
				{resetMsg ? (
					resetMsg.type ? (
						<AlertMsg message={resetMsg} type={"success"} />
					) : (
						<AlertMsg message={resetMsg} type={"error"} />
					)
				) : null}
			</DialogContent>
			<DialogActions>
				<Button
					variant="contained"
					color="secondary"
					sx={{ color: "white" }}
					onClick={handleResetPassword}>
					تغییر رمز عبور
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default ResetPassModal;
